import { Box, Text } from "@chakra-ui/react";
import { usePersonalizacao } from "../../../context/usePersonalizacao";
import { validaValidadede } from "../../../utils";

export function TextValidade({ props, ofertas = false }) {
  const {
    validadede,
    validadeate,
    validade,
    validoapartir = validaValidadede({
      validadede: validadede,
    }),
    limitecompra,
    saldoutilizado,
    esgotado: esgotadoValue,
    esgotado = esgotadoValue ? true : false,
  } = props;

  const {
    personalizacao: { card },
  } = usePersonalizacao();

  return (
    <Box paddingTop="0.25rem" paddingBottom="0.25rem">
      {!ofertas ? (
        !validoapartir &&
        !esgotado &&
        card.textValidadeCompradas &&
        limitecompra ? (
          <>
            <Text color="#555861" fontSize="0.625rem">
              {!validoapartir && limitecompra !== ""
                ? `Limitado a ${limitecompra} | Compradas: ${
                    saldoutilizado === undefined ? 0 : saldoutilizado
                  }`
                : validade}
            </Text>
            {limitecompra !== "" && (
              <Text color="#555861" fontSize="0.625rem" marginTop="0.5rem">
                Oferta válida até{" "}
                {new Intl.DateTimeFormat("pt-BR", {
                  timeZone: "UTC",
                }).format(new Date(validadeate))}
              </Text>
            )}
          </>
        ) : (
          <Text color="#555861" fontSize="0.625rem">
            {!validoapartir && limitecompra
              ? `Até ${limitecompra}. (até ${new Intl.DateTimeFormat("pt-BR", {
                  timeZone: "UTC",
                }).format(new Date(validadeate))}).`
              : validade}
          </Text>
        )
      ) : (
        !validoapartir && (
          <Text color="#555861" fontSize="0.625rem">
            {validade}
          </Text>
        )
      )}
    </Box>
  );
}
